import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { selectClickedRoomNumberInModal } from "../Floorplan/floorplanSelectors";
import { setClickedRoomNumberInModalInRedux } from "../Floorplan/floorplanSlice";

export const useIssueTableRoomViewerModal = (issueBoardId: string) => {
  const dispatch = useAppDispatch();
  const clickedRoomNumberInModal = useAppSelector(selectClickedRoomNumberInModal);

  const closeRoomViewerModal = useCallback(() => {
    dispatch(setClickedRoomNumberInModalInRedux({ issueBoardId, clickedRoomNumberInModal: null }));
  }, [dispatch, issueBoardId]);

  useEffect(() => {
    return () => {
      dispatch(setClickedRoomNumberInModalInRedux({ issueBoardId, clickedRoomNumberInModal: null }));
    };
  }, [dispatch, issueBoardId]);

  return {
    closeRoomViewerModal,
    clickedRoomNumberInModal,
  };
};
